import React, { useState } from "react";
import DeliveryHead from "../DeliveryHead";
import {
  Grid,
  Container,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

import { Formik, Form, Field, ErrorMessage } from "formik";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";
import RouteOrderDetails from "./RouteOrderDetails";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../../shared/commonstyle/PhoneStyle";
import CommonPhoneInputs from "../../../shared/authinput/CommonPhoneInputs";
import AutocompleteLocations from "../../../shared/map/AutocompleteLocations";
import { AutocompleteMain } from "../../../shared/map/AutocompleteStyle";

import {
  RouteStepMain,
  InputFlexWrap,
  CheckBoxMain,
  ErrorSpan,
} from "../styles/RouteStopOneStyle";
import { RouteStopOnevalidation } from "../../../../helpers/validations/delivery/RouteSteps";

const RouteStopOne = () => {
  const [NextStep, SetNextStep] = useState(false);
  const [PhoneError, SetPhoneError] = useState(false);

  const handleSubmit = (values) => {
    // console.log("values", values);
    const { phoneNumber } = values;
    const isValid = isValidPhoneNumber(phoneNumber);
    if (!isValid) {
      SetPhoneError(true);
      return;
    } else {
      SetNextStep(true);
    }
  };

  const handleChange = (value, event, form) => {
    SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }

    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
  };

  return (
    <>
      {!NextStep ? (
        <>
          <DeliveryHead
            Value={25}
            BackLink="/delivery-type"
            CenterText="Request a Route  &nbsp;  - &nbsp; First Stop"
            StepText="1 of 4"
            MobileMainText="Request a Route"
            MobileSubText="First Stop"
            MobileMoreText={true}
          />
          <RouteStepMain>
            <Container maxWidth="lg">
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} md={10} lg={8}>
                  <Formik
                    initialValues={{
                      ContactName: "",
                      phoneNumber: "",
                      EmailAddress: "",
                      SelectType: "",
                      Location: "",
                      Notes: "",
                    }}
                    validationSchema={RouteStopOnevalidation}
                    onSubmit={handleSubmit}
                  >
                    {(formik) => (
                      <Form autocomplete="off">
                        <InputFlexWrap>
                          <Field
                            type="text"
                            name="ContactName"
                            label="Contact Name"
                            component={AuthInput}
                            placeholder="Enter your name"
                          />
                          {/* <Field
                            type="number"
                            name="PhoneNumber"
                            label="Phone Number"
                            component={AuthInput}
                            placeholder="Enter your number"
                          /> */}
                          <PhoneInputsMain
                            className={`AuthInputMain  ${
                              formik.touched.phoneNumber &&
                              formik.errors.phoneNumber &&
                              "is__error"
                            }`}
                          >
                            <CustomLabel>Phone Number</CustomLabel>
                            <Field name="phoneNumber">
                              {({ field, form }) => (
                                <CommonPhoneInputs
                                  {...field}
                                  onChange={(value, event) =>
                                    handleChange(value, event, form)
                                  }
                                />
                              )}
                            </Field>
                            <ErrorMessage
                              name="phoneNumber"
                              component="span"
                              className="error"
                            />
                          </PhoneInputsMain>
                        </InputFlexWrap>

                        <InputFlexWrap>
                          <Field
                            type="text"
                            name="EmailAddress"
                            label="Email Address"
                            component={AuthInput}
                            placeholder="Enter your email"
                          />
                          <CheckBoxMain>
                            <FormControl>
                              <FormLabel id="demo-radio-buttons-group-label">
                                Select Type
                              </FormLabel>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue=""
                                name="SelectType"
                                value={formik.values.SelectType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                <FormControlLabel
                                  value="Pickup"
                                  control={<Radio />}
                                  label="Pick-up"
                                />
                                <FormControlLabel
                                  value="Dropoff"
                                  control={<Radio />}
                                  label="Drop-off"
                                />
                              </RadioGroup>
                            </FormControl>
                            {formik.touched.SelectType &&
                              formik.errors.SelectType && (
                                <ErrorSpan>
                                  {formik.errors.SelectType}
                                </ErrorSpan>
                              )}
                          </CheckBoxMain>
                        </InputFlexWrap>
                        <InputFlexWrap>
                          {/* <Field
                            type="text"
                            name="Location"
                            label="Pickup / Drop-off Location"
                            component={AuthInput}
                            placeholder="Enter your name"
                          /> */}
                          <AutocompleteMain className="AuthInputMain ">
                            <CustomLabel>
                              Pickup / Drop-off Location
                            </CustomLabel>
                            <Field name="Location">
                              {({ field, form }) => (
                                <AutocompleteLocations {...field} form={form} />
                              )}
                            </Field>
                            <ErrorMessage
                              name="Location"
                              component="span"
                              className="error"
                            />
                          </AutocompleteMain>
                          <Field
                            type="text"
                            name="Notes"
                            label="Notes"
                            component={AuthInput}
                            placeholder="Any Notes here..."
                          />
                        </InputFlexWrap>
                        {PhoneError && (
                          <span
                            className="Phoneerror"
                            style={{
                              color: "red",
                              textTransform: "capitalize",
                            }}
                          >
                            Invalid phone number
                          </span>
                        )}
                        <MainButton
                          type="submit"
                          label="Add Order Details"
                          MT="90"
                        />
                      </Form>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </Container>
          </RouteStepMain>
        </>
      ) : (
        <RouteOrderDetails NavigateCallback={SetNextStep} StepCount={1} />
      )}
    </>
  );
};

export default RouteStopOne;
